module.exports = __webpack_public_path__ + "media/images/steps/png/214-laptop-e5670da0f0764b05ad589da4feecc04a.png";